import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '../buttons/Button';
import AddIcon from '../icons/Add';

import styles from '../../../styles/partials/add-box.module.css';

interface AddBoxProps {
    className?: string | null;
}

function AddBox({ className = null }: AddBoxProps) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.cols}>
                <div className={styles.col}>
                    <AddIcon className={styles.icon} />
                </div>
                <div className={styles.col}>
                    <div className={styles.inner}>
                        <div className={styles.label}>
                            <FormattedMessage
                                defaultMessage="Vous souhaitez afficher votre événement?"
                                description="Add box label prompting to display event"
                            />
                        </div>
                        <Button href={'/fr/contactez-nous'} className={styles.button} white small>
                            <FormattedMessage
                                defaultMessage="Contactez-nous!"
                                description="Contact us button in add box"
                            />
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddBox;
